"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPERIMENT_VARIATION_SEPARATOR = exports.EXPERIMENT_SERIALIZATION_SEPARATOR = exports.SERIALIZED_COMPONENT_SEPARATOR = exports.END_DATE_KEY = exports.START_DATE_KEY = exports.DEFAULT_KEY = void 0;
exports.DEFAULT_KEY = "default";
exports.START_DATE_KEY = "start@";
exports.END_DATE_KEY = "end@";
exports.SERIALIZED_COMPONENT_SEPARATOR = "|";
exports.EXPERIMENT_SERIALIZATION_SEPARATOR = " ";
exports.EXPERIMENT_VARIATION_SEPARATOR = ":";
